import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';


const CollaborationCard = ({ collaboration, onAccept, onDecline }) => {
  const getStatusColor = (status) => {
    const colors = {
      'pending': 'bg-warning/20 text-warning',
      'active': 'bg-success/20 text-success',
      'completed': 'bg-muted text-muted-foreground'
    };
    return colors?.[status] || 'bg-muted text-muted-foreground';
  };

  const getStatusText = (status) => {
    const texts = {
      'pending': 'قيد الانتظار',
      'active': 'نشط',
      'completed': 'مكتمل'
    };
    return texts?.[status] || status;
  };

  return (
    <div className="bg-transparent p-4 md:p-5 transition-all duration-300">
      <div className="flex items-start gap-3 md:gap-4 mb-3 md:mb-4">
        <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0 shadow-[0_4px_12px_rgba(0,0,0,0.08)]">
          <Image
            src={collaboration?.initiatorAvatar}
            alt={collaboration?.initiatorAvatarAlt || collaboration?.initiatorName || 'صورة المنشئ'}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm md:text-base font-heading text-foreground mb-1">
            {collaboration?.initiatorName}
          </h4>
          <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">
            {collaboration?.projectTitle}
          </p>
        </div>
        <span className={`px-2 md:px-3 py-1 rounded-full text-xs font-medium flex-shrink-0 ${getStatusColor(collaboration?.status)}`}>
          {getStatusText(collaboration?.status)}
        </span>
      </div>
      <p className="text-xs md:text-sm text-muted-foreground mb-3 md:mb-4 line-clamp-2">
        {collaboration?.description}
      </p>
      <div className="flex flex-wrap items-center gap-2 md:gap-3 text-xs text-muted-foreground mb-3 md:mb-4">
        <div className="flex items-center gap-1">
          <Icon name="Users" size={14} />
          <span>{collaboration?.collaborators} كاتب</span>
        </div>
        <div className="flex items-center gap-1">
          <Icon name="Calendar" size={14} />
          <span>{collaboration?.deadline}</span>
        </div>
      </div>
      {collaboration?.status === 'pending' && (
        <div className="flex gap-2">
          <button
            onClick={() => onAccept(collaboration?.id)}
            className="flex-1 px-4 py-2 rounded-full border border-primary bg-transparent text-primary text-sm font-medium hover:bg-primary/5 transition-all duration-300 flex items-center justify-center gap-2"
          >
            <Icon name="Check" size={16} />
            <span>قبول</span>
          </button>
          <button
            onClick={() => onDecline(collaboration?.id)}
            className="flex-1 px-4 py-2 rounded-full border border-muted-foreground/30 bg-transparent text-muted-foreground text-sm font-medium hover:bg-muted/20 transition-all duration-300 flex items-center justify-center gap-2"
          >
            <Icon name="X" size={16} />
            <span>رفض</span>
          </button>
        </div>
      )}
      {collaboration?.status === 'active' && (
        <button
          className="w-full px-4 py-2 rounded-full border border-primary bg-transparent text-primary text-sm font-medium hover:bg-primary/5 transition-all duration-300 flex items-center justify-center gap-2"
        >
          <Icon name="ExternalLink" size={16} />
          <span>متابعة المشروع</span>
        </button>
      )}
    </div>
  );
};

export default CollaborationCard;